import Cookies from 'cookies-js';

import ngettext from '@eb/ngettext';

import {
    getFollowOrganizerStatus,
    getFollowCollectionStatus,
} from '@eb/destination-utils';

import {
    NOTIFICATION_COOKIE,
    NOTIFICATION_COOKIE_COLLECTION,
} from '../constants';

export const getUpcomingEventCopy = (numUpcomingEvents) =>
    ngettext('upcoming event', 'upcoming events', numUpcomingEvents);

const hasFollowOrganizerCookie = (type) => {
    const cookie =
        type === 'organizer'
            ? NOTIFICATION_COOKIE
            : NOTIFICATION_COOKIE_COLLECTION;

    const notificationCookieValue = Cookies.get(cookie);

    return notificationCookieValue !== undefined;
};

const explicitOptIn = 1;
const explicitOptOut = 2;
const explicitChoices = [explicitOptIn, explicitOptOut];

export const hasAlreadyChosen = async (type, userId) => {
    let hasChosen = false;
    const getFollowStatus =
        type === 'organizer'
            ? getFollowOrganizerStatus
            : getFollowCollectionStatus;
    try {
        const response = await getFollowStatus(userId);
        hasChosen =
            explicitChoices.includes(
                response['preferences'][0]['global_preference'],
            ) &&
            explicitChoices.includes(
                response['preferences'][1]['global_preference'],
            );
    } catch (error) {
        // If the api fails we should still show the GDPR modal.
    }
    return !hasChosen;
};

export const shouldShowGDPRModal = async (
    type = 'organizer',
    isGDPRCountry = true,
    userId,
    launchCommSettingsFollowAction = false,
) => {
    if (!isGDPRCountry) {
        return false;
    } else if (launchCommSettingsFollowAction) {
        return hasAlreadyChosen(type, userId).then((resp) => resp);
    } else {
        return !hasFollowOrganizerCookie(type);
    }
};
